export default {
  Vehicle_IN: 'VEHICLE ARRIVED',
  PANEL_REPAIR: 'PANEL REPAIR',
  PAINT_PREPARATION: 'PAINT PREPARATION',
  PAINT: 'PAINT',
  PANEL_FIT_UP: 'PANEL FIT UP',
  POLISH_AND_DETAILING: 'WASH & VACUUM',
  FINAL_INSPECTION: 'FINAL INSPECTION',
  READY_FOR_PICKUP: 'REPAIRS FINALISED',
  PICKUP_SCHEDULED: 'PICKUP SCHEDULED',
  PICKUP_COMPLETE: 'PICKED UP'
}